import React, { Component } from "react";
import { shape, node, string } from "prop-types";

import * as i18nUtils from "util/i18n";

import AccountsListItem from "pages/accounts/ListItem";
import WidgetList from "pages/desktop/widgets/WidgetList";
import WidgetHeader from "./_components/WidgetHeader";

class Accounts extends Component {
    static propTypes = {
        closeButton: node,
        draggableItemProps: shape({}).isRequired,
        goTo: string,
    };

    static defaultProps = {
        closeButton: null,
        goTo: "",
    };

    render() {
        const { closeButton, draggableItemProps, goTo } = this.props;
        const uiAutomationProp = { "data-ui-automation": "widgetAccounts" };
        return (
            <WidgetList
                limitTo={6}
                item={AccountsListItem}
                keyExtractor={(item) => item.idProduct}
                name="accounts"
                {...this.props}>
                {(list) => (
                    <section
                        className="widget accounts"
                        {...uiAutomationProp}
                        {...draggableItemProps}
                        aria-roledescription={i18nUtils.get("desktop.widgets.message.roleDescription")}>
                        <WidgetHeader title={i18nUtils.get("menu.accounts")} action={closeButton} goTo={goTo} />
                        {list}
                        <div className="overlay" />
                    </section>
                )}
            </WidgetList>
        );
    }
}

export default Accounts;
